<nb-card>
  <nb-card-header>{{ 'standings_form.title' | translate }}</nb-card-header>
  <nb-card-body>
    <form [formGroup]="standingsForm" [nbSpinner]="loading"
          nbSpinnerStatus="danger"
          nbSpinnerSize="large"
          nbSpinnerMessage="">
      <app-form-input
        id="game_wins"
        [label]="'standings_form.game_wins' | translate"
        type="number"
        [min]="0"
        [required]="true"
        formControlName="game_wins"
        [control]="getControl('game_wins')"
      />

      <app-form-input
        id="game_losses"
        [label]="'standings_form.game_losses' | translate"
        type="number"
        [min]="0"
        [required]="true"
        formControlName="game_losses"
        [control]="getControl('game_losses')"
      />
      <app-form-input
        id="map_wins"
        [label]="'standings_form.map_wins' | translate"
        type="number"
        [min]="0"
        [required]="true"
        formControlName="map_wins"
        [control]="getControl('map_wins')"
      />

      <app-form-input
        id="map_losses"
        [label]="'standings_form.map_losses' | translate"
        type="number"
        [min]="0"
        [required]="true"
        formControlName="map_losses"
        [control]="getControl('map_losses')"
      />
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="form-buttons">
      <button nbButton status="danger" (click)="cancel()">{{ 'common.cancel' | translate }}</button>
      <button nbButton status="primary" (click)="submit()" [disabled]="!standingsForm.valid">{{ 'common.save' | translate }}</button>
    </div>
  </nb-card-footer>
</nb-card>
